export const brandStrategy = {
  seo: {
    title: "Márka és stratégia — Bespire AI asszisztens",
    description:
      "Új arculat, persona-finomítás, üzleti terv, versenytárs-elemzés. A Bespire AI asszisztens folyamatosan segít a márkádon.",
  },
  hero: {
    badge: "Márka és stratégia",
    title: "A márkád, ami tényleg rólad szól",
    subtitle:
      "Nem sablon-workshop, nem 40 oldalas PDF. A Bespire AI folyamatosan finomítja az arculatod, üzeneteid és pozíciódat — a saját foglalásaid, ügyfeleid és a versenytársaid mozgásai alapján.",
    ctaTrial: "Próbáld ki 3 napig ingyen",
    ctaPricing: "Nézd meg az árakat →",
    brandCard: {
      label: "Márkakártya · illusztráció",
      businessName: "Bella Studio",
      tagline: "Kismama jóga, ami tényleg megnyugtat.",
      paletteLabel: "Paletta",
      palette: [
        { name: "Rose", hex: "#F5B5C6" },
        { name: "Sage", hex: "#B8CBB5" },
        { name: "Sand", hex: "#EFE3D0" },
        { name: "Ink", hex: "#2B2530" },
      ],
      typographyLabel: "Tipográfia",
      heading: "Playfair Display",
      body: "Manrope",
      voiceLabel: "Hangvétel",
      voice: ["Meleg", "Nyugodt", "Bátorító"],
    },
  },
  process: {
    title: "Három lépés, hogy a márkád magától is dolgozzon",
    subtitle:
      "Nem egyszeri projekt. Minden lépés élő — az adataid változásával a Bespire is finomítja a következtetéseit.",
    steps: [
      {
        step: "01",
        icon: "Target",
        title: "Pozicionálás",
        description:
          "Ki vagy, kinek szólsz, miben vagy más. A Bespire a saját ügyfél- és versenytárs-adataidból húzza össze a válaszokat — nem sablon-kérdőívből.",
        bullets: [
          "3–5 valós versenytárs pozíció-térképe",
          "Saját ügyfelek szegmentálása foglalások alapján",
          "Egy mondatos pozicionálás, ami átér a marketingedre is",
        ],
      },
      {
        step: "02",
        icon: "Palette",
        title: "Identitás",
        description:
          "Színek, tipográfia, hangvétel, vizuális rendszer — a személyiségedhez, a fő szegmensedhez és az iparágadhoz igazítva.",
        bullets: [
          "3 paletta-variáció A/B tesztre",
          "Tipográfia-párosítás és mikro-rendszer",
          "Hangvétel-útmutató példákkal (nem elvekkel)",
        ],
      },
      {
        step: "03",
        icon: "MessageCircle",
        title: "Üzenetek",
        description:
          "Egy mondat, ami az egész marketingedet vezeti. Onnan lebomlik weboldal-szövegekre, posztokra, hirdetésekre — mindenhol egységesen.",
        bullets: [
          "Fő üzenet + 3 alverzió különböző szegmensekre",
          "Kész mondat-építőkocka posztokhoz",
          "Márkakönyv, ami minden újabb tartalomra érvényes marad",
        ],
      },
    ],
  },
  beforeAfter: {
    title: "Előtte–utána: ugyanaz a vállalkozás",
    subtitle:
      "Nem szebb szöveg. Egy másik pozíció, másik célszegmens, másik üzenet — ugyanabból az emberből.",
    before: {
      label: "Előtte",
      businessName: "Kata Masszázs",
      tagline: "Masszázs Budapesten. Bejelentkezés telefonon.",
      bio: "Több éves tapasztalattal várom kedves vendégeimet, különböző masszázs típusokkal. Bejelentkezés telefonon.",
      problems: [
        "Nem derül ki, ki a célközönség",
        "Semmi nem különbözteti meg mástól",
        "A hangvétel személytelen",
      ],
    },
    after: {
      label: "Utána",
      businessName: "Kata — Regeneráció túlterhelt szülőknek",
      tagline: "45 perc csend, ami után újra bírod a napot.",
      bio: "Kifejezetten dolgozó szülőknek dolgozom. Nem wellness — regeneráció: kevés beszéd, sok csend, késő délutáni időpontok. Első alkalom 30% kedvezmény.",
      wins: [
        "Egyértelmű célközönség (dolgozó szülők)",
        "Egyértelmű ígéret (regeneráció, nem wellness)",
        "Egyértelmű különbség (csend + időpont-választás)",
      ],
    },
  },
  gallery: {
    title: "Ne csak beszéljünk róla — mutassuk",
    subtitle:
      "A Bespire élőben generál palettát, tipográfiát, hangvételt — te választasz, ő testre szab.",
    styles: [
      {
        name: "Nyugodt studio",
        heading: "Playfair",
        body: "Manrope",
        tone: "Meleg · Csendes · Prémium",
        palette: ["#F5B5C6", "#B8CBB5", "#EFE3D0", "#2B2530"],
      },
      {
        name: "Modern klinika",
        heading: "Inter",
        body: "Inter",
        tone: "Tiszta · Szakértő · Megbízható",
        palette: ["#0EA5E9", "#F1F5F9", "#0F172A", "#22D3EE"],
      },
      {
        name: "Energikus fitnesz",
        heading: "Space Grotesk",
        body: "Manrope",
        tone: "Bátor · Direkt · Motiváló",
        palette: ["#F97316", "#111827", "#F3F4F6", "#FDBA74"],
      },
      {
        name: "Természetes bio",
        heading: "Fraunces",
        body: "Nunito",
        tone: "Őszinte · Meleg · Kézműves",
        palette: ["#65A30D", "#F5F5DC", "#3F3F46", "#FDE68A"],
      },
      {
        name: "Kreatív műhely",
        heading: "Recoleta",
        body: "Manrope",
        tone: "Játékos · Merész · Egyedi",
        palette: ["#8B5CF6", "#F472B6", "#FEF3C7", "#1F2937"],
      },
      {
        name: "Elegáns coaching",
        heading: "Cormorant",
        body: "Inter",
        tone: "Csendes · Igényes · Bizalmi",
        palette: ["#334155", "#E2E8F0", "#C7A17A", "#0F172A"],
      },
    ],
  },
  chat: {
    title: "Kérdezd meg úgy, mintha egy stratégához beszélnél",
    subtitle:
      "Csak nem 250.000 Ft-ért egyszer, hanem bármikor a nap folyamán, valós adatok alapján.",
    chat: {
      title: "Márka asszisztens",
      online: "Online",
      messages: [
        { role: "user" as const, content: "Meg szeretném újítani az arculatomat. Mennyibe kerül nálatok egy brand refresh?" },
        { role: "assistant" as const, content: "Ez már benne van az előfizetésedben. Nézzük meg együtt: az adatok szerint az elmúlt 3 hónapban 3 új szegmensed lett — melyikre pozicionáljuk?" },
        { role: "user" as const, content: "A 30–45 éves dolgozó szülők a fő ügyfeleim." },
        { role: "assistant" as const, content: "Rendben. Készítettem 3 moodboardot erre a szegmensre:", list: [
          "🎨 Nyugodt Studio — csendes prémium, este 6+ időpontok",
          "🌿 Természetes bio — család-fókusz, hétvégi csomagok",
          "✨ Kreatív műhely — közösségi, workshop-alapú",
        ] },
        { role: "user" as const, content: "Az elsőt bontsuk ki." },
        { role: "assistant" as const, content: "Kész: paletta, tipográfia, 5 poszt, új landing szöveg, hangvétel-útmutató. Ha jóváhagyod, ma élesítem az oldaladon. 🚀" },
      ],
    },
  },
  crossLinks: {
    title: "A márkád nem áll meg itt",
    subtitle: "A Bespire ugyanezt az arculatot használja a weboldalon, a marketingben, az ügyfél-üzenetekben és a napi ritmusodban.",
  },
  cta: {
    title: "Kezdd el a márkád finomhangolását ma",
    subtitle: "3 nap ingyenes próba, kártya nélkül.",
    primary: "Próbáld ki 3 napig ingyen",
    secondary: "Árak megnézése",
  },
};
